import PrivateLayout from "@/components/layouts/private-layout";
import DashboardPage from "@/pages/dashboard";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/")({
  component: DashboardPageComponent,
});

function DashboardPageComponent() {
  return (
    <PrivateLayout>
      <DashboardPage />
    </PrivateLayout>
  );
}
